import { getHelpUrl } from '@src/state/site/selectors'
import site from '@src/state/site/site'
import * as React from 'react'

// Last resort error page with no external dependencies in case any errors are thrown at the provider level

const fontStyles = {
  fontFamily: `'Aspira', 'Aspira Webfont', 'Helvetica', 'Arial', 'Arimo', 'Liberation Sans', sans-serif`,
}

const linkStyle = {
  color: '#00799e',
  fontSize: '1rem',
  lineHeight: '1rem',
  fontWeight: 'bold' as const,
  textDecoration: 'none' as const,
  marginBottom: 8,
  ...fontStyles,
}

const anchorStyle = {
  color: '#00799e',
  fontWeight: 'bold' as const,
  textDecoration: 'none' as const,
  ...fontStyles,
}

const containerStyle = {
  padding: 60,
  alignItems: 'center' as const,
  flexDirection: 'column' as const,
  display: 'flex' as const,
}

export const SOMETHING_WENT_WRONG_TEXT = 'It seems like something went wrong.'
export const SUPPORT_PAGE_HREF_TEST_ID = 'support-page'

const SimpleErrorPage: React.FunctionComponent<{}> = () => (
  <main>
    <div style={containerStyle}>
      <h1 style={fontStyles}>We're sorry</h1>
      <p style={fontStyles}>{SOMETHING_WENT_WRONG_TEXT}</p>
      <p style={fontStyles}>
        We'll try to fix this right away. If the problem persists, please contact support.
      </p>
      <a style={linkStyle} href="/papers">
        Back to Papers
      </a>
      <a
        style={anchorStyle}
        data-test={SUPPORT_PAGE_HREF_TEST_ID}
        href={getHelpUrl(site)}
        target="_blank"
      >
        Contact support
      </a>
    </div>
  </main>
)

export default SimpleErrorPage



// WEBPACK FOOTER //
// ./src/pages/ErrorPage/SimpleErrorPage.tsx